import { useState } from "react";
import { Card } from "@/components/ui/card";
import { useToast } from "@/components/ui/use-toast";
import { Brain } from "lucide-react";

const DocumentAnalysis = () => {
  const { toast } = useToast();
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleDocumentAnalysis = async (file: File) => {
    setIsAnalyzing(true);
    try {
      const imageUrl = URL.createObjectURL(file);
      toast({
        title: "Document Analysis Started",
        description: "Analyzing document...",
      });
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Analysis Failed",
        description: "There was an error analyzing the document.",
      });
    } finally {
      setIsAnalyzing(false);
    }
  };

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Document Analysis</h2>
      <div className="space-y-4">
        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) handleDocumentAnalysis(file);
          }}
          className="hidden"
          id="document-upload"
        />
        <label
          htmlFor="document-upload"
          className="block w-full p-4 border-2 border-dashed rounded-lg text-center cursor-pointer hover:border-primary"
        >
          Drop document for AI analysis
        </label>
      </div>
    </Card>
  );
};

export default DocumentAnalysis;